import * as React from 'react';

// tslint:disable:max-line-length
export const BenchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M12.588 6.882h-.424c.263-.451.424-.97.424-1.53 0-1.688-1.37-3.058-3.059-3.058-.013 0-.025.004-.038.004A2.669 2.669 0 0 0 6.853 0a2.676 2.676 0 0 0-2.677 2.676c0 .26.049.506.118.743a3.046 3.046 0 0 0-1.647 2.699c0 .29.054.566.13.832A3.059 3.059 0 0 0 3.411 13H7v3h2v-3h3.588a3.059 3.059 0 0 0 0-6.118z"
    />
  </svg>
);
